(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["partner-portal"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.pp-qty-btn').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var input = btn.parentElement.querySelector('.pp-qty-input');
    var next = (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.step, 10);
    input.value = Math.min(Math.max(next, input.min || 0), input.max || 999);
  });
});

(function () {
  var maInput = document.getElementById('pp-mitarbeiter');
  if (!maInput) return;
  var hint = document.getElementById('pp-mat-hint');
  var hintN = document.getElementById('pp-mat-hint-n');
  var qtys = document.querySelectorAll('.pp-qty-input[data-faktor]');

  function berechne() {
    var ma = parseInt(maInput.value, 10) || 0;
    qtys.forEach(function (q) {
      var basis  = parseFloat(q.dataset.basis)  || 0;
      var faktor = parseFloat(q.dataset.faktor) || 0;
      var stufe  = Math.max(parseInt(q.dataset.runden, 10) || 1, 1);
      var max    = parseInt(q.dataset.max, 10) || 0;
      var v = 0;
      if (ma > 0) {
        v = Math.round((basis + faktor * ma) / stufe) * stufe;
        if (max > 0 && v > max) v = max;
        if (v < basis) v = basis;
      }
      q.value = Math.min(Math.max(Math.round(v), 0), 999);
    });
    if (hint && hintN) { hintN.textContent = ma; hint.hidden = ma <= 0; }
  }

  maInput.addEventListener('input', berechne);
  maInput.addEventListener('change', berechne);

  // Enter im Mitarbeiterfeld: nur neu berechnen und zum ersten Mengenfeld springen, nicht absenden
  maInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      berechne();
      var first = qtys[0];
      if (first) { first.focus(); first.select(); }
    }
  });
})();

// Enter in Mengen- und Adressfeldern soll das Formular ebenfalls nicht absenden
(function () {
  var form = document.getElementById('PartnerMaterialForm');
  if (!form) return;
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t.tagName === 'INPUT' && t.type !== 'submit') { e.preventDefault(); }
  });
})();

// Bestätigungsansicht: Daten beim Absenden merken, nach Erfolg anzeigen
(function () {
  var form = document.getElementById('PartnerMaterialForm');
  var KEY = 'pp_bestellung';

  // 1) Beim Absenden alle relevanten Werte in sessionStorage legen
  if (form) {
    form.addEventListener('submit', function () {
      var daten = [];
      form.querySelectorAll('.pp-addr input, .pp-qty-input, #pp-anmerkung').forEach(function (el) {
        var label = '';
        if (el.classList.contains('pp-qty-input')) {
          var row = el.closest('.pp-mat-row');
          label = row ? row.querySelector('.pp-mat-label').textContent.trim() : '';
          if (!el.value || el.value === '0') return;   // Nullmengen nicht in die Zusammenfassung
        } else if (el.id === 'pp-anmerkung') {
          label = 'Anmerkung';
          if (!el.value.trim()) return;
        } else if (el.closest('.pp-ma-row')) {
          label = 'Mitarbeiteranzahl';
          if (!el.value.trim()) return;
        } else {
          label = el.placeholder || '';
          if (!el.value.trim()) return;
        }
        daten.push([label, el.value.trim()]);
      });
      try { sessionStorage.setItem(KEY, JSON.stringify(daten)); } catch (e) {}
    });
  }

  // 2) Nach Erfolg: Zusammenfassung rendern, Formular ausblenden
  var summary = document.getElementById('pp-summary');
  if (summary) {
    var wrap = document.querySelector('.pp-form');
    if (wrap) wrap.classList.add('pp-form--done');
    try {
      var daten = JSON.parse(sessionStorage.getItem(KEY) || '[]');
      if (daten.length) {
        var table = document.createElement('table');
        daten.forEach(function (d) {
          var tr = document.createElement('tr');
          var td1 = document.createElement('td'); td1.textContent = d[0];
          var td2 = document.createElement('td'); td2.textContent = d[1];
          tr.appendChild(td1); tr.appendChild(td2); table.appendChild(tr);
        });
        summary.appendChild(table);
      }
      sessionStorage.removeItem(KEY);
    } catch (e) {}
    var ok = document.getElementById('pp-success');
    if (ok) ok.scrollIntoView({ block: 'center' });
  }
})();

document.querySelectorAll('.pp-code-copy').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var code = btn.dataset.code;
    var done = function () {
      btn.textContent = 'Kopiert';
      btn.classList.add('is-copied');
      setTimeout(function () { btn.textContent = 'Kopieren'; btn.classList.remove('is-copied'); }, 2000);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(ta);
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
